import { H2 } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';

import { ArticleTileContainer, InnerContainer } from './styles';
import { ExtendedCmsInsuranceTypeContent } from '../../../pages/insurance/types';
import ArticleTile from './components/article-tile';
import WrappedSection from '../wrapped-section';

type ArticlesSectionProps = {
  articles: ExtendedCmsInsuranceTypeContent['articles'];
  insuranceType: string;
};

const ArticlesSection = ({ articles, insuranceType }: ArticlesSectionProps) => (
  <WrappedSection withBorder withWide>
    <InnerContainer>
      <H2 looksLike="h3" variant={['marginBottomSpacer6', 'center']}>
        Articles that might interest you
      </H2>
      {!isEmpty(articles) && (
        <ArticleTileContainer>
          {map(
            (article) => (
              <ArticleTile article={article} insuranceType={insuranceType} key={article.name} />
            ),
            articles,
          )}
        </ArticleTileContainer>
      )}
    </InnerContainer>
  </WrappedSection>
);

export default ArticlesSection;
